import React from 'react';

function wrapperStyle({ constants }) {
  const style = {
    paddingTop: constants.KEYFIELD_WRAPPER_PADDING_TOP
  };
  return style;
}

function fieldMessageStyle({ styles, constants, color }) {
  const fontSize = constants.KEYFIELD_MESSAGE_FONT_SIZE;

  const style = {
    ...styles.fontStyle,
    fontSize,
    height: constants.KEYFIELD_MESSAGE_HEIGHT,
    lineHeight: `${constants.KEYFIELD_MESSAGE_HEIGHT}px`,
    marginBottom: constants.KEYFIELD_MESSAGE_MARGIN_BOTTOM,
    color: color.grey['600'],
    textAlign: 'center'
  };
  return style;
}

function fieldStyle({ constants, color }) {
  const style = {
    position: 'relative',
    width: constants.KEYFIELD_FIELD_WIDTH,
    height: constants.KEYFIELD_FIELD_HEIGHT,
    backgroundColor: color.white,
    margin: 'auto',
    borderRadius: 4,
    border: `1px solid ${color.grey['400']}`
  };
  return style;
}

function fieldCursorStyle({ number, constants, color }) {
  const halfFieldHeight = constants.KEYFIELD_FIELD_HEIGHT / 2;
  const halfCursorHeight = constants.KEYFIELD_CURSOR_HEIGHT / 2;
  const halfFieldWidth = constants.KEYFIELD_FIELD_WIDTH / 2;
  const halfNumberWidth = constants.KEYFIELD_NUMBER_WIDTH / 2;
  let cursorStart = halfFieldWidth - halfNumberWidth;

  cursorStart += constants.KEYFIELD_CURSOR_LEFT_POSITIONS[number.length];

  const style = {
    position: 'absolute',
    top: halfFieldHeight - halfCursorHeight,
    left: cursorStart,
    width: constants.KEYFIELD_CURSOR_WIDTH,
    height: constants.KEYFIELD_CURSOR_HEIGHT,
    backgroundColor: color.blue['500']
  };

  return style;
}

function fieldNumberStyle({ number, constants, color }) {
  const showPlaceholder = number.length === 0;
  const halfFieldHeight = constants.KEYFIELD_FIELD_HEIGHT / 2;
  const halfFieldWidth = constants.KEYFIELD_FIELD_WIDTH / 2;
  const halfNumberHeight = constants.KEYFIELD_NUMBER_HEIGHT / 2;
  const halfNumberWidth = constants.KEYFIELD_NUMBER_WIDTH / 2;

  let style = {
    fontFamily: 'Roboto Mono',
    fontSize: constants.KEYFIELD_NUMBER_FONT_SIZE,
    height: constants.KEYFIELD_NUMBER_HEIGHT,
    lineHeight: `${constants.KEYFIELD_NUMBER_HEIGHT}px`,
    position: 'absolute',
    top: halfFieldHeight - halfNumberHeight,
    left: halfFieldWidth - halfNumberWidth,
    letterSpacing: 2
  };

  if (showPlaceholder) {
    style = {
      ...style,
      color: color.grey['300']
    };
  } else {
    style = {
      ...style,
      color: color.black
    };
  }

  return style;
}

function getDisplayNumber({ number }) {
  let na = [];

  if (number.length > 0) {
    number.split('').forEach((n, i) => {
      na = [...na, n];
      if (i === 2 || i === 5) {
        na = [...na, '-'];
      }
    });
  }

  return na.join('');
}

export default props => (
  <div style={wrapperStyle(props)}>
    <div style={fieldMessageStyle(props)}>
      {props.text.SIGN_KEYFIELD_MESSAGE}
    </div>
    <div style={fieldStyle(props)}>
      <div style={fieldNumberStyle(props)}>
        {props.number.length === 0 ? '000-000-0000' : getDisplayNumber(props)}
      </div>
      <div style={fieldCursorStyle(props)} />
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/KeyField/index.js